module.exports = __webpack_public_path__ + "img/money.07a442ca.png";